document.addEventListener( 'DOMContentLoaded', function() {
    document.querySelectorAll('.WI_productCardSplide').forEach(splid => {
        var ProductCardSplide = new Splide( splid, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            arrows: true,
            pagination: false,
            breakpoints: {
                800: {
                    arrows: false
                  }
            }
        }).mount();
        // var ProductCardbar = ProductCardSplide.root.querySelector( '.WI_productCardSplide_progress_bar' );
        // ProductCardSplide.on( 'mounted move', function () {
        //     var end  = ProductCardSplide.Components.Controller.getEnd() + 1;
        //     var rate = Math.min( ( ProductCardSplide.index + 1 ) / end, 1 );
        //     ProductCardbar.style.width = String( 100 * rate ) + '%';
        //   } );
        // ProductCardSplide.mount(); 
    });
  } );
  document.addEventListener("productCardClicked", () => {
    console.log('Product Card Clicked');
    document.querySelectorAll('.WI_productCardSplide').forEach(splid => {
        var splide = new Splide( splid, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
            breakpoints: {
                800: {
                    arrows: false
                  }
            }
        }).mount();;
        
        
    });
  });